import React, { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

function PhonePePayment() {
  const [amount, setAmount] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    if (!amount || amount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post('http://localhost/letsenjoy_api/phonepepay.php', {
        amount: amount,
      });
      setResponse(res.data);

      if (res.data?.data?.instrumentResponse?.redirectInfo?.url) {
        window.location.href = res.data.data.instrumentResponse.redirectInfo.url;
      }
    } catch (err) {
      setResponse({ error: 'Payment failed. Check console for more info.' });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-lg p-4 rounded-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <h3 className="mb-3 text-center">📲 PhonePe Test Payment</h3>

        <div className="mb-3">
          <label className="form-label">Enter Amount (₹)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g., 500"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        <button
          onClick={handlePayment}
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>

        {response && (
          <div className="alert alert-info mt-4" role="alert">
            <pre className="m-0 small">{JSON.stringify(response, null, 2)}</pre>
          </div>
        )}
      </div>
    </div>
  );
}

export default PhonePePayment;
